import CoachsChallengeAPI from 'media-base-ui/utils/coachsChallengeAPI';
import actionCreators from './actionCreators';

const fetchCoachsChallenges = (fromDate, toDate, gameType = null, challengingId = null, initiator = null, opposingId = null) => async dispatch => {
    dispatch(doFetch(CoachsChallengeAPI.fetchCoachsChallenges, {
        fromDate,
        toDate,
        gameType,
        challengingId,
        initiator,
        opposingId,
    }));
};

const fetchPaginatedCoachsChallenges = (fromDate, toDate, gameType = null, challengingId = null, initiator = null, opposingId = null, start, limit, sort) => async dispatch => {
    dispatch(doFetch(CoachsChallengeAPI.fetchCoachsChallenges, {
        fromDate,
        toDate,
        gameType,
        challengingId,
        initiator,
        opposingId,
        start,
        limit,
        sort
    }));
};

const doFetch = (func, args) => async dispatch => {
    dispatch(actionCreators.requestCoachsChallenges());

    try {
        const data = await func.call(this, args);
        dispatch(actionCreators.coachsChallengesResponse(true, data, null));
    } catch (error) {
        dispatch(actionCreators.coachsChallengesResponse(false, [], error));
    }
}

export default {
    fetchCoachsChallenges,
    fetchPaginatedCoachsChallenges
}
